import { useT } from '../../i18n';
import { cx } from './classNames';
import styles from './Spinner.module.css';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  decorative?: boolean;
  labelKey?: string;
}

export function Spinner({ size = 'sm', className, decorative = false, labelKey = 'common.loading' }: SpinnerProps) {
  const { t } = useT();

  if (decorative) {
    return <span className={cx(styles.spinner, styles[size], className)} aria-hidden="true" />;
  }

  return (
    <span className={cx(styles.spinner, styles[size], className)} role="status">
      <span className={styles.srOnly}>{t(labelKey)}</span>
    </span>
  );
}
